import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["focus"];

  connect() {
    if (this.hasFocusTarget) {
      setTimeout(() => { this.focus(this.focusTarget); }, 5000)
    }
  }

  focus(el) {
    el.focus();
  }
}
